export default "__VITE_ASSET__D93lcK42__"